import { FC } from 'react';
import { Stack } from '@mui/material';
import { ROUTES } from 'config';
import { Modal, TextField } from 'melp-design/components';
import { Controller, SubmitHandler, useForm } from 'react-hook-form-latest';
import { useTranslation } from 'react-i18next';
import { useCreateEmployeeGroup } from 'store/employee-groups';
import { ModalProps } from 'store/modal';
import { routerHistory } from 'utils/router-history';
import { usePredefinedToasts } from 'utils/Toast';

interface Values {
  name: string;
}

interface Props extends ModalProps {}

export const CreateEmployeeGroupModal: FC<Props> = ({ closeModal }) => {
  const { t } = useTranslation();
  const predefinedToasts = usePredefinedToasts();

  const { handleSubmit, control } = useForm<Values>({
    defaultValues: {
      name: '',
    },
  });

  const { mutate: createEmployeeGroup, isLoading: isCreating } =
    useCreateEmployeeGroup();

  const onSubmit: SubmitHandler<Values> = (values) => {
    createEmployeeGroup(
      {
        name: values.name,
      },
      {
        onSuccess: ({ data }) => {
          predefinedToasts.success.added();
          closeModal();
          routerHistory.push(
            `${ROUTES.employeeGroups.details.replace(
              ':id',
              data.id,
            )}?tab=innerGroupAssignBenefits`,
          );
        },
      },
    );
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Modal.Content
        title={t('groups.create_employee_group')}
        actions={[
          {
            variant: 'neutral-outline',
            onClick: () => closeModal({ action: 'CLOSE' }),
            label: t('common.cancel'),
          },
          {
            variant: 'primary',
            label: t('common.create'),
            type: 'submit',
            disabled: isCreating,
          },
        ]}
      >
        <Stack gap="20px">
          <Controller
            name="name"
            control={control}
            render={({ field: { name, value, onChange, ref } }) => (
              <TextField
                label={t('groups.group_name')}
                name={name}
                value={value}
                onChange={onChange}
                required
                ref={ref}
              />
            )}
          />
        </Stack>
      </Modal.Content>
    </form>
  );
};
